import { useFormContext } from 'react-hook-form';

import { TPageForm } from '../../page-form/page-form';
import { PageVideoAssetsForm } from './page-video-assets-form';

const PageVideos = () => {
  const { control } = useFormContext<TPageForm>();

  return (
    <div className="w-100 h-100 flex-column raw-gap-20 p-0">
          <PageVideoAssetsForm
            control={control}
          />
    </div>
  );
};

export { PageVideos };
